// extracted by mini-css-extract-plugin
export default {"parent":"phoneInputSelect_parent__DNeXs","parentIcon":"phoneInputSelect_parentIcon__R-ueR","parentSkeleton":"phoneInputSelect_parentSkeleton__2LPF5"};